<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='补卡申请'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-radio-group  v-model="form.checkInType" row hide-details="auto" :rules="required">
                    <v-radio label="上下班卡" :value="1"></v-radio>
                    <v-radio label="上班卡" :value="2"></v-radio>
                    <v-radio label="下班卡" :value="3"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="form.checkInType < 3">
                <v-col cols="12">
                  <v-menu
                    ref="starMenu"
                    v-model="startPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.startTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.startTime"
                        label="上班时间"
                        readonly filled rounded
                        v-bind="attrs"
                        v-on="on"
                        hide-details="auto"
                        :rules="required"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="startPicker"
                      v-model="form.startTime"
                      full-width
                      locale='zh-cn'
                      format='24hr'
                      @click:minute="$refs.starMenu.save(form.startTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if="form.checkInType !== 2">
                <v-col cols="12">
                  <v-menu
                    ref="endMenu"
                    v-model="endPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.endTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.endTime"
                        label="下班时间"
                        readonly filled rounded
                        v-bind="attrs"
                        v-on="on"
                        hide-details="auto"
                        :rules="required"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="endPicker"
                      v-model="form.endTime"
                      full-width
                      locale='zh-cn'
                      format='24hr'
                      @click:minute="$refs.endMenu.save(form.endTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea label="申请理由" rows="4" filled rounded  :rules="required" v-model="form.remark"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" rounded :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/personal/repair.js'

  export default {
    name: 'Repair',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          type: 1,
          workTime: ''
        })
      }
    },
    data() {
      return {
        loading: false,
        startPicker: false,
        endPicker: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          type: '',
          checkInType: 1, // 1.上下班 2、上班 3、下班
          workTime: '',
          startTime: '',
          endTime: '',
          remark: ''
        },
        defForm: {
          type: '',
          checkInType: 1, // 1.上下班 2、上班 3、下班
          workTime: '',
          startTime: '',
          endTime: '',
          remark: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.defForm))
          this.form.workTime = this.item.workTime
          this.form.type = this.item.type
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
